module.exports = __webpack_public_path__ + "img/gi.6d8fd950.svg";